import TotalNetAssets from './TotalNetAssets.vue'

export default TotalNetAssets
